const user_de = {
  title: "Benutzer",
  subtitle: "Benutzerverwaltung",
  searchPlaceholder: "Suche",
  addNewUser: "Neuen Benutzer hinzufügen",
  updateUser: "Benutzer aktualisieren",
  cancel: "Abbrechen",
  table: {
    name: "Name",
    email: "E-Mail",
    role: "Rolle",
    organization: "Organisation",
    laConceptContactPerson: "LA Concept Ansprechpartner",
    lastChange: "Letzte Änderung",
    status: "Status",
    actions: "Aktionen",
    active: "Aktiv",
    inactive: "Inaktiv"
  },
  message: {
    created: "Benutzer wurde erstellt",
    createError: "Erstellen des Benutzers fehlgeschlagen",
    updated: "Benutzer wurde aktualisiert",
    updateError: "Aktualisieren des Benutzers fehlgeschlagen"
  },
  form: {
    createTitle: "Neuen Benutzer hinzufügen",
    updateTitle: "Benutzer bearbeiten",
    firstName: "Vorname",
    firstNamePlaceholder: "Vorname eingeben",
    lastName: "Nachname",
    lastNamePlaceholder: "Nachname eingeben",
    email: "E-Mail-Adresse",
    emailPlaceholder: "E-Mail-Adresse eingeben",
    phoneNumber: "Telefonnummer",
    phoneNumberPlaceholder: "Telefonnummer eingeben",
    phoneNumberInvalid: "Bitte geben Sie eine gültige Telefonnummer ein",
    position: "Position",
    positionPlaceholder: "Position eingeben",
    password: "Passwort",
    passwordPlaceholder: "Passwort eingeben",
    role: "Rolle",
    rolePlaceholder: "Rolle auswählen",
    emailRequired: "E-Mail ist erforderlich",
    emailInvalid: "E-Mail ist ungültig",
    firstNameRequired: "Vorname ist erforderlich",
    lastNameRequired: "Nachname ist erforderlich",
    passwordRequired: "Passwort ist erforderlich",
    roleRequired: "Rolle ist erforderlich"
  },
  delete: {
    title: "Benutzer löschen",
    body: "Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?",
    cancel: "Abbrechen",
    delete: "Löschen",
    success: "Benutzer wurde gelöscht",
    fail: "Löschen des Benutzers fehlgeschlagen"
  },
  detail: {
    back: "Zurück",
    editUser: "Benutzer bearbeiten",
    deleteUser: "Benutzer löschen",
    sendResetEmail: "Reset-Mail senden"
  }
}

export default user_de
